// extracted by mini-css-extract-plugin
export default {"applyBtn":"NscVehicles_applyBtn__1DiSg","actionSection":"NscVehicles_actionSection__XJNr0","vehicleName":"NscVehicles_vehicleName__02ooN"};